import React from 'react';
import { useLocation } from 'react-router-dom';
import clsx from 'clsx';
import {
  useMediaQuery,
  Theme,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import config from '../../config';
import styles from './SidePanel.styles';

type Props = {
  menuStatus?: 'collapse' | 'extend';
};

const useStyles = makeStyles(styles);

const SidePanel: React.FC<Props> = ({
  menuStatus,
}: Props) => {
  const classes = useStyles();
  const isLargeScreen = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const location = useLocation();
  return (
    <Box>
      {isLargeScreen && (
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: menuStatus === 'extend',
            [classes.drawerClose]: menuStatus === 'collapse',
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: menuStatus === 'extend',
              [classes.drawerClose]: menuStatus === 'collapse',
            }),
          }}
        >
          <List>
            <ListItem
              button
              selected={location.pathname.includes('result')}
            >
              <ListItemIcon>
                <img
                  src={`${config.routerBase}/assets/icon/micro_scope_24.png`}
                  alt="Result"
                  className={location.pathname.includes('result')
                    ? classes.menuIconActive
                    : classes.menuIconInactive}
                />
              </ListItemIcon>
              <ListItemText primary="Result" />
            </ListItem>
          </List>
        </Drawer>
      )}
    </Box>
  );
};

export default SidePanel;
